import $ from "jquery";
import {MAX_TABLET_WIDTH} from "Core/screenSizes";

const isTablet = () => {
    return window.outerWidth < MAX_TABLET_WIDTH
};

export const dropdownHover = () => {
    let timers = [];

    // if (isTablet()) {
    //     return;
    // }

    $(document).on('mouseover', '.dropdown', function () {
        const listWrapper = $(this).find('.dropdown-menu');

        if (listWrapper.length === 0) {
            return false;
        }

        listWrapper.addClass('dropdown-menu-active');

        clearTimeout(timers[$(this).data('container-id')]);

        return false;
    });

    $(document).on('mouseout', '.dropdown', function () {
        const listWrapper = $(this).find('.dropdown-menu');
        const timeId = $(this).data('container-id');

        clearTimeout(timers[timeId]);
        timers[timeId] = setTimeout(function () {
            if (listWrapper.length === 0) {
                return false;
            }

            listWrapper.removeClass('dropdown-menu-active');
        }, 400);

        return false;
    });
};

export const hideDropdown = () => {
    const listWrapper = $('.dropdown').find('.dropdown-menu-active');

    listWrapper.removeClass('dropdown-menu-active');
}
